import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useSnackbar } from 'notistack'
import utilServices from 'app/services/util-services'
import { selectItemById, getNotifybarById, updateNotifybar } from 'app/redux/store/features/notifybars'
import UpdateNotifyBarForm from './UpdateNotifyBarForm'

const UpdateNotifyBar = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { enqueueSnackbar } = useSnackbar()
    const [apiCallInProgress, setApiCallInProgress] = useState(false)
    const { state } = useLocation()
    const { id } = state
    const { notifybars, loading, error } = useSelector((state) => state.notifybars)
    const notifybar = selectItemById(notifybars, id)

    useEffect(() => {
        if (utilServices.isNullOrUndefined(notifybar.id)) dispatch(getNotifybarById({ id: id }))
    }, [])

    useEffect(() => {
        if (!apiCallInProgress || loading) return
        setApiCallInProgress(false)

        if (error) handleError(error)
        else {
            enqueueSnackbar('Notify Bar updated successfully', {
                variant: 'success',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            })
            navigate('/settings/configuration/notify-bar')
        }
    }, [loading])

    function handleError(error) {
        if (error.status === '401') {
            navigate('/profile/signout')
        } else if (error.detail) {
            enqueueSnackbar(error.detail, {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            })
        } else {
            enqueueSnackbar(error, {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            })
        }
    }

    const onUpdateNotifyBar = async () => {
        setApiCallInProgress(true)
        dispatch(
            updateNotifybar({
                ...notifybar,
                dateStart: notifybar.dateStart.toFilterStartDateTime(),
                dateEnd: notifybar.dateEnd.toFilterStartDateTime(),
            })
        )
    }

    return (
        <React.Fragment>
            <UpdateNotifyBarForm notifyBarData={notifybar} updateNotify={onUpdateNotifyBar} />
        </React.Fragment>
    )
}

export default UpdateNotifyBar
